if(!customElements.get("swym-bis-button")){
    class SwymBisButton extends HTMLElement{
        constructor(){
            super();
            this._initializeSwymComponent()
        
        }

        _initializeSwymComponent(){
            window.SwymCallbacks||(window.SwymCallbacks=[]);
            window.SwymCallbacks.push(this._init.bind(this))
        }

        _init(swat){
            this.swat = swat;
            this.bisButton = this.querySelector('.swym-add-to-watchlist-view-product'); 
            this.bisButton.addEventListener('click', this._addToWatchList.bind(this))
        }

        _addToWatchList(evt) {
            evt.preventDefault();
            const swat = this.swat; 
            const productId = +this.bisButton.getAttribute("data-product-id");
            const variantId = +this.bisButton.getAttribute("data-variant-id");
            const du = this.bisButton.getAttribute("data-url");
            const params = {
              empi: productId,
              epi: variantId,
              du: du,
            };
            swat.getProductDetails(params, function(productJSON) {
              productJSON.variants.forEach(function(v) {
                if (v.id == variantId) {
                  params.pr = SwymUtils.formatProductPrice(v.price);
                  params.iu = productJSON.featured_image;
                  params.et = 8;
                  swat.addToWatchList(evt, params, function(e) {
                    console.log("Subscribed to product!", e);
                  });
                  return;
                }
              });
            });
          }
    }
    customElements.define("swym-bis-button",SwymBisButton)
}